<template lang="pug">
  div.event-center
    .event-center-con.layout_screen_width
      event-info(:event="event" :collect="collect")
      div.event-analysis
        EventSideNav(:event="event")
        div.event-view
          keep-alive
            router-view(:event="event")
      event-compare(:evts="evts" :event="event" :bottom="bottom" v-if="isLogged")
      div.report(v-if="event.reportId && isLogged" @click.prevent="reportView")
        img.report_icon(src="../assets/img/components/危机报告.png")
        p 危机报告
</template>
<script>
import EventSideNav from './EventSideNav'
import EventInfo from './EventInfo'
import EventCompare from './EventCompare'
import client from '../server/server'
import store from '../store'
export default {
  name: 'EventCenter',
  beforeRouteEnter (to, from, next) {
    store.dispatch('updateCompareIds', []).then(res => {
      next()
    })
  },
  data () {
    return {
      event: {
        eventName: '',
        hasCollect: false,
        hasRule: false,
        imgUrl: '',
        introduction: '',
        priBrand: '',
        priCrisisTags: [],
        reportId: null,
        secBrands: [],
        secCrisisTags: [],
        crisisTags: '',
        firstPlatform: null,
        firstAccount: null
      },
      evts: [],
      bottom: 20
    }
  },
  created () {
    this.$route.query.share && client.getShare(this.$route.query.share)
    !this.$route.query.share && store.dispatch('GetUserinfo')
  },
  mounted () {
    this.getEventDetail()
  },
  computed: {
    isLogged () {
      return this.$store.getters.logged
    }
  },
  methods: {
    getEventDetail () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventDetail(params).then(res => {
        if (res.success) {
          this.event = Object.assign({}, this.event, res.data, {
            imgUrl: res.data.imgUrl
              ? this.$imgParse(res.data.imgUrl)
              : require('@index/assets/img/event_default.png'),
            secBrands: res.data.secBrands.length
              ? res.data.secBrands.join('、')
              : '',
            crisisTags: res.data.priCrisisTags
              .concat(res.data.secCrisisTags)
              .join('、')
          })
          this.evts = res.data.compareEvents.map(d => {
            return {
              imgUrl: d.imgUrl
                ? this.$imgParse(d.imgUrl)
                : require('@index/assets/img/event_default.png'),
              eventName: d.eventName,
              id: d.id
            }
          })
          this.bottom = res.data.reportId ? 110 : 20
        }
      })
    },
    reportView () {
      let route = this.$router.resolve({
        name: 'PdfViewer',
        params: { id: this.event.reportId }
      })
      window.open(route.href, '_blank')
    },
    collect (id, boolean) {
      let data = {
        id: id,
        collect: boolean
      }
      client.changeEventCollect(data).then(res => {
        if (res.success) {
          this.event.hasCollect = boolean
        } else {
          return new Error(res.message)
        }
      })
    }
  },
  components: {
    EventSideNav,
    EventInfo,
    EventCompare
  }
}
</script>
<style lang="scss" scoped>
.event-center {
  width: 100%;
  height: 100%;
  background-color: #e8ebf1;
  overflow-y: auto;
  overflow-x: hidden;
  .event-center-con {
    width: 100%;
    padding: 24px 0;
  }
  .event-analysis {
    display: flex;
    .event-view {
      flex: 1;
    }
  }
  .report {
    width: 66px;
    height: 66px;
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: fixed;
    right: 20px;
    bottom: 20px;
    text-align: center;
    cursor: pointer;
    img.report_icon {
      margin-top: 12px;
    }
    p {
      margin-top: 5px;
      color: #f87e5c;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventCenter/EventCenter.vue